import { gql } from "@apollo/client";

export const GET_USER = gql`
  query Query {
    user {
      id
      firstName
      lastName
      emailAddress
      signUpDate
      applications {
        id
        status
        jobPosting {
          role
          team
          employer {
            employerName
            employerId
          }
          location {
            city
            state
            zipCode
          }
        }
      }
      jobCart {
        jobPosting {
          id
          role
          team
          description
          employer {
            employerName
            employerId
          }
          location {
            city
            state
            zipCode
          }
          fields {
            required
            fieldId
            field {
              title
              type
              value
            }
          }
        }
      }
    }
  }
`;

export const GET_JOB_POSTINGS = gql`
  query Query($whatSearchFilter: String!, $locationFilters: [String!]) {
    jobPostings(
      whatSearchFilter: $whatSearchFilter
      locationFilters: $locationFilters
    ) {
      id
      role
      team
      description
      employer {
        employerName
        employerId
      }
      fields {
        required
        fieldId
        field {
          title
          type
          value
        }
      }
      location {
        city
        state
        zipCode
      }
    }
  }
`;

export const GET_JOB_POSTING_BY_ID = gql`
  query Query($jobPostingId: Int!) {
    jobPostingById(jobPostingId: $jobPostingId) {
      id
      role
      team
      description
      employer {
        employerName
      }
      fields {
        required
        fieldId
        field {
          title
          type
          value
        }
      }
      location {
        city
        state
        zipCode
      }
    }
  }
`;

export const GET_LOCATIONS = gql`
  query Query($filter: String!) {
    locations(filter: $filter) {
      id
      city
      stateId
    }
  }
`;
